export default "__VITE_ASSET__CUp77d7S__"